import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'
import data from '@/components/Feature/Rankings/Data'
import Ranking from '@/components/Feature/Rankings/Ranking'
import TitleSelector from '@/components/Feature/Rankings/TitleSelector'
import { CalidadDeLosAlumnos } from '@/components/Feature/Rankings/Output'

const IndexPage = () => {
  const rankings = data.filter(item => item.name === 'Rankings')[0].rankings
  const datalocal = rankings.find(
    item =>
      item.link === '/rankings-generales/percepcion-de-calidad-de-los-alumnos/',
  )

  return (
    <Layout>
      <SEO
        title={datalocal.name}
        keywords={[
          `La Tercera`,
          `${datalocal.name}`,
          `Ranking de Universidades Chilenas 2021`,
        ]}
      />
      <Content>
        <TitleSelector
          pretitle="Ranking de Universidades 2021"
          allRankings={rankings}
          section="rankings-generales"
          sectionSlug={datalocal.slug}
        />
        <Columns>
          <p>
            Aunque con variaciones menores, la posición de las universidades con
            respecto a 2020 se mantiene: son las mismas casas de estudio las que
            están en los primeros 10 lugares. La sorpresa vino de la mano de la
            U. del Desarrollo, plantel que subió tres puestos, ubicándose en el
            séptimo, gracias al alza del promedio NEM de sus alumnos de primer
            año: un 6,4, lejos del 6,07 que registró el año pasado. La que
            desciende es la U. de Playa Ancha, pese a que las notas de sus
            alumnos subieron de 5,85 a 6,11, el promedio PDT tuvo una fuerte
            baja, cayó de 520,78 a 497,42, con lo cual descendió siete puestos.
          </p>

          <p>
            En cuanto a los promedios PDT, solo cuatro universidades registran
            más de 600 puntos: Católica, de Chile, de los Andes y Adolfo Ibáñez,
            tres menos que el año pasado. Mientras que entre los últimos puestos
            hay cinco planteles que presentan promedios PDT inferiores a los 500
            puntos, a la U. de Playa Ancha se suman las universidades de Los
            Lagos (497,08), de Viña del Mar (452,78), de Las Américas (446,61) y
            Adventista (478,22).
          </p>

          <p>
            Y si se revisan las notas de la Enseñanza Media, son los mismos
            cinco planteles que desde 2013 encabezan este indicador: Católica
            con un 6,74 y de Chile con un 6,69. Les siguen las universidades de
            los Andes, Adolfo Ibáñez y de Concepción, las que presentan un
            promedio superior a 6,5.
          </p>

          <p>
            Uno de los efectos de la pandemia fue el alza de notas de los
            alumnos. Si en el proceso de admisión 2019-2020, fueron 21 las casas
            de estudio que registraron sobre un 6 de promedio de notas de sus
            alumnos, este año subieron a 34 los planteles.
          </p>

          <p>
            Entre la U. Católica, plantel que registra el puntaje PDT más alto,
            y la U. Adventista, con el promedio más bajo, existe una diferencia
            de 178 puntos. Mientras los alumnos de la primera anotan 656,27, los
            de la segunda alcanzan los 478,22.
          </p>
        </Columns>
        <CalidadDeLosAlumnos />
        <Summary />
      </Content>
    </Layout>
  )
}

export default IndexPage
